import React from 'react';

const DEFAULT_TERMS = [
  {
    heading: 'Price',
    content: 'paragraph',
    text: 'The above quoted prices are on ex-works basis from our facility in Noida.',
  },
  {
    heading: 'Payment Terms',
    content: 'list',
    items: ['50% against formal Purchase Order', '50% prior to dispatch'],
  },
  {
    heading: 'Taxes & Duties',
    content: 'paragraph',
    text: 'GST @ 18% will be further added on the quoted amount as applicable under GST regulations.',
  },
  {
    heading: 'Freight & Transportation',
    content: 'paragraph',
    text: 'Freight charges will be applicable on "to-pay" basis as per actual cost and distance.',
  },
  {
    heading: 'Warranty',
    content: 'paragraph',
    text: 'One (1) Year warranty against any manufacturing defects. Warranty excludes third-party equipment such as Motors, Burners, etc., which carry their respective manufacturer warranties.',
  },
  {
    heading: 'Delivery',
    content: 'paragraph',
    text: 'Delivery within 30 to 45 days from the date of formal Purchase Order receipt along with advance payment.',
  },
  {
    heading: 'Ducting & Civil Work',
    content: 'list',
    items: [
      'Ducting work is NOT in our scope of supply',
      'Any civil work required will be at your end',
      'Installation support and training provided by our specialized engineer',
    ],
  },
  {
    heading: 'Installation & Training',
    content: 'paragraph',
    text: 'Start-up assistance and comprehensive training provided by specialized Gema engineer for automatic system operation and maintenance.',
  },
  {
    heading: 'Proposal Validity',
    content: 'paragraph',
    text: 'This proposal is valid for 30 days from the date of submission. Prices and specifications are subject to change thereafter.',
  },
  {
    heading: 'Force Majeure',
    content: 'paragraph',
    text: 'We shall not be liable for any failure or delay in delivering goods due to force majeure events beyond reasonable control including natural disasters, war, pandemics, or government actions.',
    highlight: true,
  },
];

/* Match q_4.html: margin-bottom 1.5rem, padding 1rem, white bg, yellow left border */
const blockStyle = {
  marginBottom: 8,
  background: 'white',
  padding: 8,
  borderLeft: '4px solid #ffbe0b',
};

const blockHighlightStyle = {
  ...blockStyle,
  marginBottom: 0,
  background: 'rgba(255, 190, 11, 0.1)',
  borderRadius: 4,
};

/* Match q_4.html h4: font-weight 600, margin-bottom 0.5rem, Montserrat, text-dark */
const headingStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontWeight: 600,
  fontSize: 15,
  color: '#000814',
  margin: '0 0 8px 0',
  display: 'block',
};

/* Match q_4.html p.text-dark - body text */
const textStyle = {
  fontSize: 13,
  color: '#000814',
  lineHeight: 1.8,
  margin: 0,
};

const listStyle = {
  fontSize: 13,
  color: '#000814',
  lineHeight: 1.8,
  margin: 0,
  paddingLeft: 20,
  listStylePosition: 'inside',
};

export default function TermConditions({ commercialSection = {}, termsSection = {}, signatory = {} }) {
  const closingContent = commercialSection.hierarchy?.content || [];

  return (
    <div className="a4-paddings quotation-page quotation-page-compact">
      <div className="quotation-page-inner quotation-bg-light">
        <div style={{ height: 3, backgroundColor: '#ffbe0b', marginBottom: 16 }} />
        <div className="quotation-no-break" style={{ marginBottom: 24 }}>
          <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 18, fontWeight: 700, color: '#000814', margin: '0 0 4px 0', display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ width: 40, height: 2, backgroundColor: '#ffbe0b', flexShrink: 0 }} />
            Terms & Conditions
          </h2>
        </div>

        <div style={{ fontSize: 15, lineHeight: 1.8 }}>
          {DEFAULT_TERMS.map((term, i) => (
            <div
              key={i}
              className="quotation-no-break"
              style={term.highlight ? blockHighlightStyle : blockStyle}
            >
              <h4 style={headingStyle}>{term.heading}</h4>
              {term.content === 'list' && term.items ? (
                <ul style={listStyle}>
                  {term.items.map((item, j) => (
                    <li key={j} style={{ marginBottom: 4 }}>{item}</li>
                  ))}
                </ul>
              ) : (
                <p style={textStyle}>{term.text}</p>
              )}
            </div>
          ))}
        </div>

        {(closingContent.length > 0 || signatory.name) && (
          <div className="quotation-section-block" style={{ marginTop: 20 }}>
            {closingContent.map((p, i) => (
              <p key={i} style={{ fontSize: 13, color: '#333', margin: '0 0 6px 0' }}>{p}</p>
            ))}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, marginTop: 20, alignItems: 'end' }}>
              <div>
                <p style={{ fontSize: 13, color: '#666', margin: '0 0 24px 0' }}>Authorized Signatory</p>
                <div style={{ borderTop: '1px solid #000814', paddingTop: 8 }}>
                  <p style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 13, color: '#000814', margin: 0 }}>
                    {signatory.name || 'Harish Sharma'}
                  </p>
                  <p style={{ fontSize: 13, color: '#666', margin: '4px 0 0 0' }}>{signatory.contact || '+919811846214'}</p>
                  <p style={{ fontSize: 13, color: '#666', margin: '2px 0 0 0' }}>{signatory.designation || 'Director'}</p>
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ fontSize: 13, color: '#666', margin: '0 0 8px 0' }}>{signatory.date || 'May 3, 2025'}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
